import { check_login_account, check_mobile } from '@/api/account';
var state = {
  name: ''
};
var mutations = {};
var actions = {
  // 检查账号是否注册过
  checkLoginAccount: function checkLoginAccount(_, payload) {
    return check_login_account(payload);
  },
  // 检查手机号是否存在
  checkMobile: function checkMobile(_, payload) {
    return check_mobile(payload);
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};